import { errorText } from "../utils/error-messages";

export const shareYourExperience = () => {
  const shareYourExperience = document.getElementById("share-your-experience") as HTMLDivElement;

  if (!shareYourExperience) {
    return;
  }

  const forms: NodeListOf<HTMLFormElement> = shareYourExperience.querySelectorAll(".story-form");

  forms.forEach((form) => {
    form.addEventListener("submit", (e) => {
      e.preventDefault();

      const content = form.querySelector("textarea") as HTMLTextAreaElement;

      const formData = new FormData();
      formData.append("content", content.value);

      fetch("/website-api/share-your-experience/", {
        credentials: "same-origin",
        method: "post",
        body: formData,
      })
        .then((response) => {
          if (response.status === 429) {
            throw new Error("Too many requests. Please try again later.");
          }

          return response.json();
        })
        .then((jsonResponse) => {
          if (jsonResponse.metadata.code !== 200) {
            if (jsonResponse.metadata.error_message) {
              alert(jsonResponse.metadata.error_message);

              return;
            }
            alert(errorText("generic"));
          } else {
            const step1 = shareYourExperience.querySelector(".step-1") as HTMLDivElement;
            const step2a = shareYourExperience.querySelector(".step-2a") as HTMLDivElement;
            const step2b = shareYourExperience.querySelector(".step-2b") as HTMLDivElement;
            const stepSuccess = shareYourExperience.querySelector(
              ".step-success",
            ) as HTMLDivElement;

            step1.style.display = "none";
            step2a.style.display = "none";
            step2b.style.display = "none";
            stepSuccess.style.display = "block";
          }
        })
        .catch((error) => {
          alert(error);
        });
    });
  });

  const ratingForm = shareYourExperience.querySelector(".rating-form") as HTMLFormElement;

  ratingForm.addEventListener("submit", (e) => {
    e.preventDefault();

    const easeOfUse = shareYourExperience.querySelector(".ease-of-use:checked") as HTMLInputElement;
    const satisfaction = shareYourExperience.querySelector(
      ".satisfaction:checked",
    ) as HTMLInputElement;
    const likelyToRecommend = shareYourExperience.querySelector(
      ".likely-to-recommend:checked",
    ) as HTMLInputElement;

    if (!easeOfUse || !satisfaction || !likelyToRecommend) {
      return;
    }

    const formData = new FormData();

    formData.append("ease_of_use", easeOfUse.value);
    formData.append("satisfaction", satisfaction.value);
    formData.append("likely_to_recommend", likelyToRecommend.value);

    fetch("/website-api/share-your-experience/", {
      credentials: "same-origin",
      method: "post",
      body: formData,
    })
      .then((response) => response.json())
      .then((jsonResponse) => {
        if (jsonResponse.metadata.code !== 200) {
          if (jsonResponse.metadata.error_message) {
            alert(jsonResponse.metadata.error_message);

            return;
          }
          alert(errorText("generic"));
        }
      });

    const totalCount =
      parseInt(easeOfUse.value, 10) +
      parseInt(satisfaction.value, 10) +
      parseInt(likelyToRecommend.value, 10);
    const totalAverageCount = totalCount / 3;

    const step1 = shareYourExperience.querySelector(".step-1") as HTMLDivElement;
    const step2a = shareYourExperience.querySelector(".step-2a") as HTMLDivElement;
    const step2b = shareYourExperience.querySelector(".step-2b") as HTMLDivElement;

    step1.style.display = "none";

    if (totalAverageCount > 4) {
      step2b.style.display = "block";

      return;
    }

    step2a.style.display = "block";
  });

  function manageHoverAndClick(experienceRadio: HTMLDivElement, label: HTMLLabelElement) {
    const valueStarred = parseInt(label.dataset.value as string, 10);
    const valueUnStarred = valueStarred + 1;

    const labelsStarred: NodeListOf<HTMLLabelElement> = experienceRadio.querySelectorAll(
      `label:nth-child(-n+${valueStarred})`,
    );

    labelsStarred.forEach((labelStarred) => {
      const icon = labelStarred.querySelector(".icon") as HTMLSpanElement;
      const iconActive = labelStarred.querySelector(".iconActive") as HTMLSpanElement;

      icon.classList.add("d-none");
      iconActive.classList.remove("d-none");
    });

    const labelsUnstarred: NodeListOf<HTMLLabelElement> = experienceRadio.querySelectorAll(
      `label:nth-child(n+${valueUnStarred})`,
    );

    labelsUnstarred.forEach((labelUnstarred) => {
      const icon = labelUnstarred.querySelector(".icon") as HTMLSpanElement;
      const iconActive = labelUnstarred.querySelector(".iconActive") as HTMLSpanElement;

      icon.classList.remove("d-none");
      iconActive.classList.add("d-none");
    });
  }

  const experienceRadios: NodeListOf<HTMLDivElement> =
    shareYourExperience.querySelectorAll(".experience-radio");

  experienceRadios.forEach((experienceRadio) => {
    const labels = experienceRadio.querySelectorAll("label");

    labels.forEach((label) => {
      label.addEventListener("mouseleave", () => {
        const selectedLabel = experienceRadio.querySelector("input:checked") as HTMLInputElement;

        let valueStarred = 0;

        if (selectedLabel) {
          valueStarred = parseInt(selectedLabel.value, 10);
        }

        const valueUnStarred = valueStarred + 1;

        const labelsStarred: NodeListOf<HTMLLabelElement> = experienceRadio.querySelectorAll(
          `label:nth-child(-n+${valueStarred})`,
        );

        labelsStarred.forEach((labelStarred) => {
          const icon = labelStarred.querySelector(".icon") as HTMLSpanElement;
          const iconActive = labelStarred.querySelector(".iconActive") as HTMLSpanElement;

          icon.classList.add("d-none");
          iconActive.classList.remove("d-none");
        });

        const labelsUnstarred: NodeListOf<HTMLLabelElement> = experienceRadio.querySelectorAll(
          `label:nth-child(n+${valueUnStarred})`,
        );

        labelsUnstarred.forEach((labelUnstarred) => {
          const icon = labelUnstarred.querySelector(".icon") as HTMLSpanElement;
          const iconActive = labelUnstarred.querySelector(".iconActive") as HTMLSpanElement;

          icon.classList.remove("d-none");
          iconActive.classList.add("d-none");
        });
      });

      label.addEventListener("mouseenter", () => {
        manageHoverAndClick(experienceRadio, label);
      });

      label.addEventListener("click", () => {
        manageHoverAndClick(experienceRadio, label);
      });
    });
  });
};
